export default __webpack_public_path__ + "static/columns-1a8afda88a888ec0ee9ab4ce2283f35a.jpg";